export default __webpack_public_path__ + "static/media/email.d4e6f927.svg";